import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitColumnsExtensionInterface } from '../../../extension/interface/benefit-columns.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { CustomBenefitActivationDialogExtension } from './extension/custom-benefit-activation-dialog.extension';
import { CustomBenefitColumnsExtension } from './extension/custom-benefit-columns.extension';
import { CustomBenefitMetadataExtension } from './extension/custom-benefit-metadata.extension';
import { CustomBenefitNavigationExtension } from './extension/custom-benefit-navigation.extension';

export { CustomBenefitCreator } from './customBenefitCreator/CustomBenefitCreator';
export { CustomBenefitCreatorMenu } from './customBenefitCreator/CustomBenefitCreatorMenu';
export { CustomBenefitList } from './CustomBenefitList';
export { useCustomBenefitCreatorState } from './useCustomBenefitCreator';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('custom')
    .add(BenefitMetadataExtensionInterface, new CustomBenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new CustomBenefitNavigationExtension())
    .add(BenefitColumnsExtensionInterface, new CustomBenefitColumnsExtension())
    .add(BenefitActivationDialogExtensionInterface, new CustomBenefitActivationDialogExtension())
    .build(),
);
